// store/ulgMapConfigSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    chartType: 'bubble',
    indicator: null,
    subIndicator: null,
    selectedLocations: [],
    fullIndicatorInfo: {}
};

const ulgMapConfigSlice = createSlice({
    name: 'ulgMapConfig',
    initialState,
    reducers: {
        setUlgMapConfig: (state, action) => {
            return { ...state, ...action.payload };
        },
        resetUlgMapConfig: () => initialState,
    },
});

export const { setUlgMapConfig, resetUlgMapConfig } = ulgMapConfigSlice.actions;
export default ulgMapConfigSlice.reducer;